export const NEW = 'new'
export const COMPLETION = 'completion'
export const GENERATION = 'generation'
export const PROCESSING = 'processing'
export const CLOSED = 'closed'
export const CANCELLED = 'cancelled'

export const ALL_REQUEST_DOCUMENTATION_STATUSES = [
  NEW,
  COMPLETION,
  GENERATION,
  PROCESSING,
  CLOSED,
  CANCELLED,
] as const

export type RequestDocumentationStatus =
  (typeof ALL_REQUEST_DOCUMENTATION_STATUSES)[number]
